import { render, staticRenderFns } from "./RetailSalesHistory.template.vue?vue&type=template&id=915268e2&scoped=true&"
var script = {}
import style0 from "./RetailSalesHistory.template.vue?vue&type=style&index=0&id=915268e2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915268e2",
  null
  
)

export default component.exports